module.exports = __webpack_public_path__ + "static/img/r-3-2.47181ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/r-3-2.png
// module id = Xk3S
// module chunks = 0